<template>
  <div>
    <div class="header text-center">
      <h3 class="title">Casual Labourer Management System : Notifications</h3>
      <p class="category">All Notifications From CLMS</p>
    </div>

    <div class="md-layout">
      <div class="md-layout-item md-size-50 md-small-size-100">
        <md-card>
          <md-card-header>
            <h4 class="title">User Notifications</h4>
          </md-card-header>

          <md-card-content>

            <!-- LOADING -->
            <div v-if="loading" class="text-center">
              Loading notifications...
            </div>

            <!-- TABLE -->
            <md-table v-else-if="notifications.length">

              <md-table-row>
                <md-table-head>#</md-table-head>
                <md-table-head>Notification</md-table-head>
                <md-table-head>Action</md-table-head>
              </md-table-row>

              <md-table-row
                  v-for="(notification, index) in notifications"
                  :key="notification.guidance_id"
              >
                <md-table-cell>
                  {{ rowNumber(index) }}
                </md-table-cell>

                <md-table-cell>
                  {{ notification.title }}
                </md-table-cell>

                <md-table-cell>
                  <md-button
                      class="md-primary small-btn"
                      style="width: 80px;"
                      @click="viewGuidance(notification)"
                  >
                    {{ notification.next_action }}
                  </md-button>
                </md-table-cell>
              </md-table-row>

              <div class="pagination">
                <button
                    @click="changePage(meta.current_page - 1)"
                    :disabled="meta.current_page <= 1"
                >
                  Prev
                </button>

                <button
                    @click="changePage(meta.current_page + 1)"
                    :disabled="meta.current_page >= meta.last_page"
                >
                  Next
                </button>
              </div>

            </md-table>

            <!-- EMPTY STATE -->
            <div v-else class="text-center">
              No pending notifications
            </div>

          </md-card-content>
        </md-card>
      </div>

      <div class="md-layout-item md-size-50 md-small-size-100">
        <md-card>
          <md-card-header>
            <h4 class="title">System Notifications</h4>
          </md-card-header>
          <md-card-content />
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
import Vuex from 'vuex';

export default {
  computed: {
    ...Vuex.mapGetters({
      notifications: 'notifications/items',
      meta: 'notifications/meta',
      loading: 'notifications/loading'
    })
  },

  data() {
    return {
      loadedOnce: false
    };
  },

  async created() {
    await this.loadNotifications();
  },

  methods: {
    async loadNotifications(params = {}) {
    //  return this.$store.dispatch('notifications/pending', params);
      const res = await this.$store.dispatch('notifications/pending', params);

      console.log('NOTIFICATIONS DEBUG:', res);
      return res;
    },

    rowNumber(index) {
      const page = this.meta?.current_page || 1;
      const perPage = this.meta?.per_page || 10;

      return (page - 1) * perPage + index + 1;
    },

    changePage(page) {
      const lastPage = this.meta?.last_page || 1;

      if (page < 1) page = 1;
      if (page > lastPage) page = lastPage;
      if (page === this.meta.current_page) return;

      this.loadNotifications({
        page,
        per_page: this.meta.per_page
      });
    },

    viewGuidance(notification) {
      this.$router.push({
        name: 'View Guidance',
        params: {id: notification.guidance_id}
      });
    }
  }
};
</script>
